
const STATE_CLOSED = "0";
const STATE_SUBMITTED = "1";

const sessionStorageAvailable = () => {
  return typeof sessionStorage !== 'undefined'
}

const formWasSubmitted = (locationId) => {
  let state = null;
  if (sessionStorageAvailable()) {
    state = sessionStorage.getItem(`emailcapture-${locationId}`);
  }
  return state === STATE_SUBMITTED;
}

const setFormAsClosed = (locationId) => {
  if (sessionStorageAvailable() && !formWasSubmitted(locationId)) {
    sessionStorage.setItem(`emailcapture-${locationId}`, STATE_CLOSED);
  }
}

const setFormAsSubmitted = (locationId) => {
  if (sessionStorageAvailable()) {
    sessionStorage.setItem(`emailcapture-${locationId}`, STATE_SUBMITTED);
  }
}

const formWasClosed = (locationId) => {
  let state = null;
  if (sessionStorageAvailable()) {
    state = sessionStorage.getItem(`emailcapture-${locationId}`);
  }
  return state === STATE_CLOSED;
}

export { setFormAsClosed, setFormAsSubmitted, formWasSubmitted, formWasClosed };
